import React, {Component} from 'react';

class ErrorPage extends Component {
    render() {
        return (
            <div>
                Data not Found
            </div>
        );
    }
}

export default ErrorPage;